export {
  default as outdoor,
  ReactComponent as Outdoor,
} from '@assets/icons/features-and-amenities/outdoor.svg'    
